import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Workflow, WorkflowOverview } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class WorkflowsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/workflows`;
  }

  async getWorkflows(): Promise<Workflow[]> {
    return await this.get<Workflow[]>('');
  }

  async getWorkflowList(): Promise<WorkflowOverview[]> {
    return await this.get<WorkflowOverview[]>('list');
  }

  async getWorkflow(id: string): Promise<Workflow> {
    return await this.get<Workflow>(id);
  }

  async createWorkflow(workflow: Workflow): Promise<string> {
    return await this.postWithResult<Workflow, string>('', workflow);
  }

  async updateWorkflow(workflow: Workflow): Promise<void> {
    return await this.put<Workflow>('', workflow);
  }

  async deleteWorkflow(id: string): Promise<void> {
    return await this.delete(id);
  }
}
